import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { SecondaryButton } from "styles/jss/Layout.styles";
import {
  FileInput,
  FormCheckBoxGroup,
  FormInput,
  FormRadioGroup,
} from "../../../FormControllers";

import * as yup from "yup";
export const handle_fileSize = value => {
  const maxAllowedSize = 4 * 1024 * 1024;
  if (!!value?.length) {
    return value[0].size <= maxAllowedSize;
  }
  return true;
};
export const handle_fileType = value => {
  if (!!value?.length) {
    return (
        value[0]?.type  === "application/pdf" ||
        value[0]?.type  === "application/doc" ||
        value[0]?.type  === "application/docx" ||
        value[0]?.type  === "application/msword" ||
        value[0]?.type  === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    );
  }
  return true;
};
const validationSchema = yup.object().shape({
  subject: yup.string().required("Field is Required"),
  current_situation: yup.string().required("Field is Required"),
  suggestion_situation: yup.string().required("Field is Required"),
  cons_suggestion: yup.string().required("Field is Required"),
  proposal_type: yup
    .string()
    .oneOf(["ایجادی", "پیشگیرانه", "اصلاحی"])
    .required("Field is Required"),
  security: yup
    .string()
    .oneOf(["محرمانه", "غیر محرمانه"])
    .required("Field is Required"),
  urgency: yup
    .string()
    .oneOf(["اضطراری", "غیراضطراری"])
    .required("Field is Required"),
  unit_responsible: yup.string().required("Field is Required"),
  context_proposal: yup.array().required("Field is Required"),

  attachment_1: yup
    .mixed()
      .test("fileType", "فرمت فایل غیر قابل قبول!", value => {
        return handle_fileType(value)
    })
    .test("fileSize", "حجم فایل بیشتر از 4مگ می‌باشد.", value =>
      handle_fileSize(value),
    ),
  attachment_2: yup
    .mixed()
      .test("fileType", "فرمت فایل غیر قابل قبول!", value => {
        return handle_fileType(value)
    })
    .test("fileSize", "حجم فایل بیشتر از 4مگ می‌باشد.", value =>
      handle_fileSize(value),
    ),
  attachment_3: yup
    .mixed()
      .test("fileType", "فرمت فایل غیر قابل قبول!", value => {
        return handle_fileType(value)
    })
    .test("fileSize", "حجم فایل بیشتر از 4مگ می‌باشد.", value =>
      handle_fileSize(value),
    ),
  attachment_4: yup
    .mixed()
      .test("fileType", "فرمت فایل غیر قابل قبول!", value => {
        return handle_fileType(value)
    })
    .test("fileSize", "حجم فایل بیشتر از 4مگ می‌باشد.", value =>
      handle_fileSize(value),
    ),
});

export default function Step1({ defaultFormValue, setDataForm }) {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...defaultFormValue },
  });

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <Grid container columnSpacing={10}>
        <Grid item xs={12}>
          <FormInput
            label={"عنوان پیشنهاد"}
            type="text"
            name="subject"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            label={
              "وضعیت موجود، به عبارت دیگر ایرادات و اشکالاتی که پیشنهاد موجب رفع آنها می شود را بیان کنید"
            }
            type="text"
            name="current_situation"
            multiline
            fullWidth
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            label={
              "وضعیت پیشنهادی، تغییرات مورد نظر را به صورت واضح، شفاف با ذکر کامل جزئیات بیان کنید"
            }
            type="text"
            name="suggestion_situation"
            multiline
            fullWidth
            rows={4}
          />
        </Grid>
        <Grid item xs={12}>
          <FormInput
            label={"مزایای وضعیت پیشنهادی"}
            type="text"
            name="cons_suggestion"
            multiline
            fullWidth
            rows={4}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormRadioGroup
            label={"نوع پیشنهاد"}
            name="proposal_type"
            options={[
              { label: "ایجادی", value: "ایجادی" },
              { label: "پیشگیرانه", value: "پیشگیرانه" },
              { label: "اصلاحی", value: "اصلاحی" },
            ]}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormRadioGroup
            label={"گروه بندي پيشنهادها بر اساس امنيت اطلاعات"}
            name="security"
            options={[
              { label: "محرمانه", value: "محرمانه" },
              { label: "غیر محرمانه", value: "غیر محرمانه" },
            ]}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormRadioGroup
            label={"گروه بندي پيشنهادها بر اساس فوریت اجرای پيشنهاد"}
            name="urgency"
            options={[
              { label: "اضطراری", value: "اضطراری" },
              { label: "غیراضطراری", value: "غیراضطراری" },
            ]}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <FormInput
            label={"به نظر شما کدام واحد(ها) مسئول اجرای پیشنهاد مذکور هستند؟"}
            type="text"
            name="unit_responsible"
            multiline
            fullWidth
            rows={4}
          />
        </Grid>

        <Grid item xs={12}>
          <FormCheckBoxGroup
            title={"زمینه پیشنهاد"}
            name={"context_proposal"}
            options={[
              { label: "بهبود ساختار مالی", value: "بهبود ساختار مالی" },
              {
                label: "بهبود کیفیت محصولات و پایداری تولید",
                value: "بهبود کیفیت محصولات و پایداری تولید",
              },
              { label: "تقویت انگیزه کارکنان", value: "تقویت انگیزه کارکنان" },
              { label: "مدیریت بهینه منابع", value: "مدیریت بهینه منابع" },
              {
                label: "مسائل رفاهی و بهبود شرایط کاری",
                value: "مسائل رفاهی و بهبود شرایط کاری",
              },
              {
                label: "تسهیل فرآیندها و ارتقای کیفیت کار",
                value: "تسهیل فرآیندها و ارتقای کیفیت کار",
              },
            ]}
            required
          />
        </Grid>
      </Grid>
      <Grid container columnSpacing={10} className={"filesInputWrapper"}>
        <Grid item xs={12}>
          <p className={""}>
            ارسال فایلها غیر اجباری و با محدودیت 4 مگابایت می باشد.
          </p>
        </Grid>
        <Grid item xs={12} md={6}>
          <FileInput btnText={"انتخاب فایل پیوست اول"} name={"attachment_1"}
          accept={'.pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FileInput btnText={"انتخاب فایل پیوست دوم"} name={"attachment_2"}
          accept={'.pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FileInput btnText={"انتخاب فایل پیوست سوم"} name={"attachment_3"}
          accept={'.pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FileInput
            btnText={"انتخاب فایل پیوست چهارم"}
            name={"attachment_4"}
            accept={'.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'}
          />
        </Grid>
      </Grid>
      <Grid container justifyContent={"flex-end"}>
        <SecondaryButton
          variant={"contained"}
          type={"submit"}
          onClick={handleSubmit(setDataForm)}
        >
          مرحله بعد
        </SecondaryButton>
      </Grid>
    </FormProvider>
  );
}
